import { Box, Divider, Modal, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import Button from '../../../components/Button';
import { addDiagnosisApi, updateDiagnosisApi, addUserDiagnosisApi, updateUserDiagnosisApi } from '../../../utils/api';
import { useMutation } from 'react-query';
import useStore from '../../../Store/Store';
import TextInput from '../../../components/TextInput';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AddDiagnosisModal = ({ show, onClose, recipient, refetch, activeEditData }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useStore((state) => state.user);
  const [state, setState] = React.useState({
    title: '',
    description: '',
    date: '',
    errorMessage: '',
  });

  React.useEffect(() => {
    if (!isEmpty(activeEditData)) {
      setState((prev) => {
        return {
          ...prev,
          title: activeEditData.title,
          description: activeEditData.description,
          date: activeEditData.date,
        };
      });
    }
  }, [activeEditData]);

  const addDiagnosisHandler = useMutation(recipient ? addDiagnosisApi : addUserDiagnosisApi, {
    onSuccess: async ({ data }) => {
      setState({
        title: '',
        description: '',
        date: '',
        errorMessage: '',
      });
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const updateDiagnosisHanlder = useMutation(recipient?._id ? updateDiagnosisApi : updateUserDiagnosisApi, {
    onSuccess: async ({ data }) => {
      setState({
        title: '',
        description: '',
        date: '',
        errorMessage: '',
      });
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const { title, description, date } = state;

    if (isEmpty(title) || isEmpty(description) || isEmpty(date)) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Fill all the fields' };
      });
      return;
    }

    const body = {
      title,
      description,
      date,
    };

    if (!isEmpty(activeEditData)) {
      updateDiagnosisHanlder.mutate({
        userId: user?._id,
        recipientId: recipient?._id,
        diagnosisId: activeEditData?._id,
        body,
      });
    } else {
      addDiagnosisHandler.mutate({ userId: user?._id, recipientId: recipient?._id, body });
    }
  };

  const onCloseModal = () => {
    setState({
      title: '',
      description: '',
      date: '',
      errorMessage: '',
    });
    onClose();
  };

  return (
    <Modal
      open={show}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '70%' : '30%',
          p: 6,
          bgcolor: 'background.paper',
          borderRadius: 2.5,
          // position: 'relative',
          // top: 50,
          // left: isMobile ? '4%' : '35%',
        }}
      >
        <Typography variant="h5" textAlign="center" marginBottom={'20px'}>
          {t('addDiagnosis')}
        </Typography>
        <TextInput
          label={t('title')}
          value={state.title}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                title: e.target.value,
              };
            })
          }
        />
        <TextInput
          label={t('description')}
          multiline
          value={state.description}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                description: e.target.value,
              };
            })
          }
        />
        <TextInput
          type="date"
          value={state.date}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                date: e.target.value,
              };
            })
          }
        />
        <Typography variant="subtitle1" style={{ color: 'red', marginTop: '30px' }} textAlign="center">
          {state.errorMessage && t(state.errorMessage)}
        </Typography>

        <Divider
          sx={{
            marginTop: 2,
            borderColor: '#E0E0E0',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 2,
          }}
        >
          <Button text={t('cancel')} onClick={onCloseModal} bg="light" />
          <Button text={t('submit')} onClick={handleSubmit} loading={addDiagnosisHandler.isLoading} />
        </Box>
      </Box>
    </Modal>
  );
};

export default AddDiagnosisModal;
